import { jsx as t } from "react/jsx-runtime";
import { ROTATE_CONVERSION as d } from "./index.es2374.js";
import { ICONS_COLOR_MAPPING as i } from "./index.es2359.js";
const C = ({
  type: l = "normal",
  direction: o = "down",
  outline: n = "default-gray",
  size: r = 18,
  ...e
}) => {
  const L = i[n], a = o !== "down" ? { transform: `rotate(${d[o]}deg)` } : {};
  return /* @__PURE__ */ t(
    "svg",
    {
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: `${r}px`,
      height: `${r}px`,
      style: a,
      "data-type": "chevron",
      "data-direction": o,
      ...e,
      children: l === "bold" ? /* @__PURE__ */ t(
        "path",
        {
          d: "M5.41464 6L8.98233 9.97682C8.99566 9.99168 9.00887 9.99661 9.02526 9.98837L9.05264 9.96574L12.6008 6.10179L14 7.48744L10.4519 11.3514C9.70027 12.1699 8.48753 12.2163 7.69562 11.4761L7.56768 11.3455L4 7.36866L5.41464 6Z",
          fill: L
        }
      ) : /* @__PURE__ */ t(
        "path",
        {
          d: "M13.1496 6L9.33866 10.5809C9.16446 10.7903 8.91684 10.8182 8.72198 10.6626L8.64206 10.5846L4.84146 6.12138L4 6.96053L7.8006 11.4238C8.42159 12.153 9.41398 12.1885 10.0701 11.5392L10.1891 11.4094L14 6.82853L13.1496 6Z",
          fill: L
        }
      )
    }
  );
};
export {
  C as UtilityChevronIcon
};
//# sourceMappingURL=index.es422.js.map
